import React, { useContext, useEffect } from "react";
import { Switch, Route, useLocation } from "react-router-dom";

// Internal components
import Needle from "components/Needle";
import Logo from "components/Logo";
import ArkivetLogo from "components/ArkivetLogo";
import MobileNav from "components/MobileNav";

// Routes
import Home from "pages/Home";

// Contexts
import { DataContext } from "contexts/Data";

const App = () => {
    const { pathname } = useLocation();
    const { data } = useContext(DataContext);
    useEffect(() => {
        if (pathname !== "/broderier") {
            document.body.scrollTop = 0;
        }
    }, [pathname]);

    return (
        <>
            <MobileNav />
            <Logo
                className={`logo ${
                    pathname ? "logo-link--" + pathname.replace(/\//, "") : ""
                }`}
            />
            <Needle />
            {/* <div className="bg" /> */}
            <Switch>
                {Object.entries(data.pages).map(([key, value]) => (
                    <Route
                        path={value.to["no"]}
                        component={value.component}
                        key={"no" + key}
                    />
                ))}
                {Object.entries(data.pages).map(([key, value]) => (
                    <Route
                        path={value.to["en"]}
                        component={value.component}
                        key={"en" + key}
                    />
                ))}
                {/* <Route path="/bakgrunn" component={Bakgrunn} />
                <Route path="/inspirasjon" component={Inspirasjon} />
                <Route path="/galleri" component={Galleri} />
                <Route path="/broderier" component={Broderier} /> */}
                <Route path="/" component={Home} />
            </Switch>
            <ArkivetLogo
                className={`arkivet-logo ${
                    pathname
                        ? "arkivet-logo-link--" + pathname.replace(/\//, "")
                        : ""
                }`}
            />
        </>
    );
};

export default App;
